"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _makeDefaultKeyFunction = _interopRequireDefault(require("./makeDefaultKeyFunction"));

var makeDataMapper = function makeDataMapper(name, _ref) {
  var mapData = _ref.mapData,
      _ref$memoizeData = _ref.memoizeData,
      memoizeData = _ref$memoizeData === void 0 ? true : _ref$memoizeData;

  if (!mapData) {
    return function (data) {
      return data;
    };
  }

  if (typeof mapData !== 'function') {
    throw new Error("Property \"mapData\" passed as configuration for entity \"".concat(name, "\" is not a function."));
  }

  var mapper = function mapper(data) {
    return mapData(data);
  };

  if (!memoizeData) {
    return mapper;
  } // Some environments don't support WeakMap, and this package
  // does not polyfill. Just skip memoization if this is the case.

  /* istanbul ignore next */


  if (typeof WeakMap === 'undefined') {
    return mapper;
  }

  var cache = new WeakMap();
  return function (data) {
    // WeakMap only supports objects as keys.
    // (It also supports functions and other object-like types,
    // but those don't really make sense in the context of entity data).
    var isDataObjectType = data && (0, _typeof2["default"])(data) === 'object';

    if (!isDataObjectType) {
      return mapper(data);
    }

    if (!cache.has(data)) {
      var result = mapper(data);
      cache.set(data, result);
      return result;
    }

    return cache.get(data);
  };
};

var typeCreator = function typeCreator(prefix) {
  return {
    resetAction: function resetAction() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _objectSpread2["default"])({
        type: "".concat(prefix, "_RESET")
      }, payload);
    },
    requestAction: function requestAction() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _objectSpread2["default"])({
        type: "".concat(prefix, "_LOAD")
      }, payload);
    },
    successAction: function successAction() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _objectSpread2["default"])({
        type: "".concat(prefix, "_SUCCESS")
      }, payload);
    },
    errorAction: function errorAction() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _objectSpread2["default"])({
        type: "".concat(prefix, "_ERROR")
      }, payload);
    },
    types: ["".concat(prefix, "_RESET"), "".concat(prefix, "_LOAD"), "".concat(prefix, "_SUCCESS"), "".concat(prefix, "_ERROR")]
  };
};

var selectKeyedState = function selectKeyedState(state, key) {
  return state[key || 'default'];
};

var selectKeys = function selectKeys(state) {
  return Object.keys(state.loading).filter(function (key) {
    return key !== 'lastKey';
  });
};

var selectData = function selectData(state, key, dataMapper) {
  return dataMapper(selectKeyedState(state.data, key)) || null;
};

var selectError = function selectError(state, key) {
  return selectKeyedState(state.error, key) || null;
};

var selectLoading = function selectLoading(state, key) {
  return selectKeyedState(state.loading, key) || false;
};

var selectLoaded = function selectLoaded(state, key) {
  return selectKeyedState(state.loaded, key) || false;
};

var selectAsyncAttributes = function selectAsyncAttributes() {
  return {
    data: selectData.apply(void 0, arguments),
    error: selectError.apply(void 0, arguments),
    loading: selectLoading.apply(void 0, arguments),
    loaded: selectLoaded.apply(void 0, arguments)
  };
};

var _default = function _default(name, promise) {
  var extras = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var dataMapper = makeDataMapper(name, extras);
  return (0, _objectSpread2["default"])({
    name: name,
    promise: promise,
    transformData: function transformData(data) {
      return data;
    }
  }, extras, {
    defaultKey: (0, _makeDefaultKeyFunction["default"])(extras.defaultKey)
  }, typeCreator(name), {
    mapData: dataMapper,
    keys: function keys(selector, state) {
      return selectKeys(selector(state));
    },
    data: function data(selector, state, key) {
      return selectData(selector(state), key, dataMapper);
    },
    error: function error(selector, state, key) {
      return selectError(selector(state), key);
    },
    loaded: function loaded(selector, state, key) {
      return selectLoaded(selector(state), key);
    },
    loading: function loading(selector, state, key) {
      return selectLoading(selector(state), key);
    },
    select: function select(selector, state, key) {
      return selectAsyncAttributes(selector(state), key, dataMapper);
    },
    lastLoadedKey: function lastLoadedKey(selector, state) {
      return selector(state).loaded.lastKey;
    },
    lastRequestedKey: function lastRequestedKey(selector, state) {
      return selector(state).loading.lastKey;
    }
  });
};

exports["default"] = _default;